import client from '../../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../../utils/redux-tool'
import setStudentFinalGradesReducer from './final-grades'
import setStudentAttendanceReducer from './attendance'
import setCourseEnrollmentReducers from './course-session-enrollment'
import setEsignReducer from './esign'

const name = 'parent-student'
const initialState = {
  list: null,
  count: null,
  query: {
    limit: 10,
    offset: 0,
  },
  selectedStudent: null,
  esign: {
    list: null,
  },
}

export const search = createApiAction('academic/student/search', client.search('/api/student/list'))

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {
    setSelectedStudent: (state, action) => {
      state.selectedStudent = action.payload;
    }
  },
  extraReducers(builder) {
    builder.addCase(search.fulfilled, (state, action) => {
      state.list = action.payload.rows
      state.count = action.payload.count
      state.query = action.meta.arg

      if (action.payload.rows?.length) {
        state.selectedStudent = action.payload.rows[0];
      } else {
        state.selectedStudent = null;
      }
    })
    setStudentFinalGradesReducer(builder)
    setStudentAttendanceReducer(builder)
    setCourseEnrollmentReducers(builder)
    setEsignReducer(builder)
  },
})

export const { setSelectedStudent } = sessionSlice.actions
export default sessionSlice.reducer
